import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';;
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import moment from 'moment';
import { ProxyDynamicService } from '../../shared/service/proxy-dynamic.service';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-service-change-card-item',
  templateUrl: './change-card.component.html',
  styleUrl: './change-card.component.scss'
})
export class ChangeCardItemComponent implements OnInit, AfterViewInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formGroup!: FormGroup;
  data: any = {};
  curentDate = moment().endOf('day').toDate();
  errorDate: string = '';
  errorNewCardNo: string = '';
  get f() {
    return this.formGroup.controls;
  }

  constructor(
    private modal: NzModalRef,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private service: ProxyDynamicService,
    private translate: TranslateService
  ) {
    if (this.nzModalData.dataRow) {
      this.data = JSON.parse(JSON.stringify(this.nzModalData.dataRow));
    }
  }

  private duplicateCardNoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value && control.value === this.data?.card_no
        ? { duplicateCardNo: true }
        : null;
    };
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      activated_date: [null, Validators.required],
      card_no: [null],
      owner: [null],
      apartment_ids: [null],
      new_card_no: [null, [Validators.required, this.duplicateCardNoValidator()]],
      note: [null]
    });
  }

  ngAfterViewInit(): void {
    this.f['activated_date'].setValue(this.curentDate);
    // this.f['activated_date'].disable();
    this.f['card_no'].disable();
    this.f['card_no'].setValue(this.data.card_no);
    this.f['owner'].disable();
    this.f['owner'].setValue(this.data.card_owner);
    this.f['apartment_ids'].disable();
    this.f['apartment_ids'].setValue(this.data.apartment_codes);

    this.f['activated_date'].valueChanges.subscribe((value: Date) => {
      if (moment(value).isBefore(this.data.activated_date)) {
        this.f['activated_date'].setErrors({ 'invalid': true });
        this.errorDate = this.translate.instant('service-card.error-change-date');
      }
      else {
        this.f['activated_date'].setErrors(null);
        this.errorDate = '';
      }
    });

    this.f['new_card_no'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      if (this.f['new_card_no'].hasError('duplicateCardNo')) {
        this.errorNewCardNo = this.translate.instant('service-card.error-same-card-no');
      } else {
        this.errorNewCardNo = '';
      }
    });
  }

  destroyModal() {
    this.modal.destroy()
  }

  onSave() {
    if (this.formGroup.valid) {
      this.sharedService.showLoading(true);
      const body = {
        service_card_id: this.data.card_id,
        card_no: this.f['new_card_no'].value,
        deposit_date: moment(this.f['activated_date'].value).utc(true).format('YYYY-MM-DD'),
        note: this.f['note'].value,
      };
      this.service.changeCard(body).subscribe(() => {
        this.sharedService.showLoading(false);
        this.modal.destroy(true);
      }, (error: any) => {
        this.service.handleError(error)
        this.modal.destroy(false);
      });
    } else {
      this.sharedService.showLoading(false);
      Object.values(this.formGroup.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
}


